import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Preloader = _resolveComponent("Preloader")!
  const _component_LeftSidebar = _resolveComponent("LeftSidebar")!
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_SettingsSidebar = _resolveComponent("SettingsSidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Preloader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSidebar && !_ctx.isNotFound)
      ? (_openBlock(), _createBlock(_component_LeftSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
      'main-content d-flex flex-column',
      { active: _ctx.stateStoreInstance.open },
      { 'padding-minus': _ctx.shouldShowPaddingLeftZero || _ctx.isNotFound },
    ])
    }, [
      (_ctx.shouldShowHeader && !_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_TopHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.containerClass)
      }, [
        _createVNode(_component_router_view)
      ], 2),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      (_ctx.shouldShowFooter && !_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_MainFooter, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_SettingsSidebar)
    ], 2)
  ], 64))
}